"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PayButton_1 = require("./PayButton");
exports.default = PayButton_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/containers/PayButton/index.js
// module id = 72
// module chunks = 0 1